import React from 'react'

const labelDefaults = {on: 'On', off: 'Off'}
const Switch = ({label: {on, off} = labelDefaults, checked, onChange}) => (
    <div className="switch">
        <label className="switch__wrapper">
            {off}
            <input type="checkbox" onChange={onChange} checked={checked} />
            <span className="switch__control" />
            {on}
        </label>
    </div>
)

export default Switch



// WEBPACK FOOTER //
// ./src/components/ui/Switch.js